import React from "react";
import Classnames from "classnames";
import {
  toUpperCaseFirst,
  toLowerCaseFirst,
  matchAfterUrl,
} from "../../../../../../../ReactConst";
import _ from "lodash";

class Feculents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
      showListAutre: false,
    };
    this.openListAutre = this.openListAutre.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeList = this.handleChangeList.bind(this);
    this.windowClick = this.windowClick.bind(this);
  }
  //On controle les events avec cette fonction
  windowClick(event) {
    if (
      this.state.showMore &&
      !event.target.classList.contains("autre-react") &&
      !event.target.classList.contains("autre-plus")
    ) {
      this.setState({
        showListAutre: false,
        showMore: false,
      });
    }
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.windowClick, false);
  }
  componentDidMount() {
    if (window) {
      window.addEventListener("click", this.windowClick, false);
    }
  }
  openListAutre() {
    this.setState((prevState) => ({ showListAutre: !prevState.showListAutre }));
  }
  handleChange = (fecule) => {
    if (fecule.id === "autre-composant-repas") {
      this.setState((prevState) => ({
        showMore: !prevState.showMore,
      }));
    } else {
      let data = { id: fecule.id, name: fecule.libelle };
      this.setState({ showMore: false });
      this.props.handleChangeFeculents(data);
    }
  };
  handleChangeList = (legume) => {
    let data = { id: legume.id, name: legume.libelle };
    this.props.handleChangeFeculents(data);
  };
  render() {
    if (!_.isEmpty(this.props.aliments.FECULENTS)) {
      const feculArray = this.props.aliments.FECULENTS;
      return (
        <div className="tab-pane active" id="repas-legumes" role="tabpanel">
          <div className="row mx-n2 mb-4 d-flex align-items-center choices-objets objet-sante">
            {feculArray.slice(0, 8).map((fecule, index) => (
              <div
                className="col-md-4 px-2"
                key={index}
                onClick={() => this.handleChange(fecule)}
              >
                <input
                  type="radio"
                  className="d-none"
                  id={fecule.id}
                  value={fecule.libelle}
                  name={fecule.libelle}
                />
                <label
                  htmlFor={fecule.libelle}
                  className={Classnames(matchAfterUrl(fecule.urlPicto), {
                    active: Array.from(this.props.recapAliments).includes(
                      fecule.libelle
                    ),
                  })}
                >
                  <span>{toUpperCaseFirst(fecule.libelle)}</span>
                </label>
              </div>
            ))}
            {feculArray.length > 8 ? (
              <div className="col-md-4 px-2 autre-react">
                <input
                  type="radio"
                  className="d-none autre-react"
                  onClick={() =>
                    this.handleChange({
                      id: "autre-composant-repas",
                      name: "autre",
                    })
                  }
                  id="autre-composant-repas"
                  value="autre-composant-repas"
                  readOnly
                  checked={this.state.showMore}
                  name="legumesChoix"
                />
                <label
                  htmlFor="autre-composant-repas"
                  className={Classnames("autre-react plus-de-legumes", {
                    active: feculArray
                      .slice(8)
                      .some((fecule) =>
                        Array.from(this.props.recapAliments).includes(
                          fecule.libelle
                        )
                      ),
                  })}
                >
                  <span className="autre-react">Autre</span>
                </label>
              </div>
            ) : (
              ""
            )}
          </div>

          {this.state.showMore ? (
            <div className="d-flex justify-content-center mt-4">
              <div className="btn-group recap-repas dropdown autre-plus">
                <button
                  onClick={() => {
                    this.openListAutre();
                  }}
                  type="button"
                  className="custom-input box-shadow btn-show-autre-repas dropdown-toggle autre-plus"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Plus de Feculents{" "}
                </button>
                {this.state.showListAutre ? (
                  <div
                    className="dropdown-menu box-shadow autre-plus"
                    style={{ display: "block" }}
                  >
                    <ul style={{ maxHeight: "195px" }} className="autre-plus">
                      {feculArray.slice(8).map((fecule, index) => {
                        return (
                          <li
                            className={Classnames("autre-plus", {
                              active: Array.from(
                                this.props.recapAliments
                              ).includes(fecule.libelle),
                            })}
                            key={index}
                            onClick={() => this.handleChangeList(fecule)}
                          >
                            <label
                              htmlFor={fecule.libelle}
                              className={Classnames("autre-plus", {
                                active: Array.from(
                                  this.props.recapAliments
                                ).includes(fecule.libelle),
                              })}
                              style={{ display: "inline" }}
                            >
                              <span className="autre-plus">
                                {toUpperCaseFirst(fecule.libelle)}
                              </span>
                            </label>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      );
    } else {
      return "";
    }
  }
}

export default Feculents;
